import { useState, useEffect } from 'react';
import { getUserLoginInfo, IUserLoginInfo } from '@/api/user';
import { PromiseState } from '@/constants';

const useLoginInfo = () => {
  const [account, setAccount] = useState({status: PromiseState.PENDING});


  useEffect(() => {
    getUserLoginInfo().then((res: IUserLoginInfo) => {
      setAccount({ ...account, ...res, status: PromiseState.FULFILLED });
    }).catch(() => {
      setAccount({ ...account, status: PromiseState.REJECTED });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return account;
};

export default useLoginInfo;
